var AsyncRequestStatus = /* @__PURE__ */ ((AsyncRequestStatus2) => {
  AsyncRequestStatus2[AsyncRequestStatus2["Pending"] = 0] = "Pending";
  AsyncRequestStatus2[AsyncRequestStatus2["Failed"] = 1] = "Failed";
  AsyncRequestStatus2[AsyncRequestStatus2["Completed"] = 2] = "Completed";
  AsyncRequestStatus2[AsyncRequestStatus2["NotStarted"] = 3] = "NotStarted";
  AsyncRequestStatus2[AsyncRequestStatus2["Stale"] = 4] = "Stale";
  return AsyncRequestStatus2;
})(AsyncRequestStatus || {});
export {
  AsyncRequestStatus
};
//# sourceMappingURL=IAsyncWrapper.js.map
